import { defaultTheme, Text } from '@agro-club/agroclub-shared'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

export type BgBadgeColors = 'primary' | 'purple' | 'green' | 'red'

const bgColors = {
  primary: defaultTheme.color.primary16a,
  purple: defaultTheme.color.purple16a,
  green: defaultTheme.color.accentApprove16a,
  red: defaultTheme.color.accentDestruct16a,
}

const BadgeStyles = styled.div<{ color: BgBadgeColors }>`
  height: 20px;
  padding: 2px 4px;
  border-radius: 4px;

  background-color: ${({ color }) => bgColors[color]};
`

type Props = {
  color?: BgBadgeColors
  children: ReactNode
}
//TODO Докрутить и унести в шаред(Никита обещал когда то добавить компонент в макет)
export const Badge: FC<Props> = ({ color = 'primary', children }) => {
  return (
    <BadgeStyles color={color}>
      <Text typography="accentSmall">{children}</Text>
    </BadgeStyles>
  )
}
